<template lang='pug'>
  #rsv-cal.rsv-cal.container.component( v-if='!rsv' )
    header
      span.legend-item
        span.clr.cus
          img.cus2(src='/ui/customer-w.svg' width='20')
        span.text {{ $t('Personal Reservation') }}
      span.legend-item
        span.clr.can-cus
        span.text {{ $t('Canceled Service') }}

    vue-cal.cal.vuecal--blue-theme.calendar(
      default-view="week"
      small
      :time-step='30'
      :disable-views="['years', 'year']"
      :selected-date="new Date()"
      :events="events"
      :on-event-click='view'
      @ready='scrollToNow'
      style="height: 750px"
    )

  bf-overlay( v-else @close='rsv = false' )
    h5.section-heading {{ $t('Reservation/Appointment Details') }}

    rsv-dtls.overlay(
      v-if='rsv'
      :rsv='rsv'
      :options='{ show: { biz: true } }'
    )

    rsv-msgs#rsv-msgs(
      v-if='rsv && account'
      :rsv='rsv'
      :account='account'
      :key='rsv.id'
    )
</template>

<script>
  import { db } from '@/main'
  import VueCal from 'vue-cal'

  export default {
    name: 'usr.calendar.component',

    components: {
      VueCal
    },

    props: {
      user: Object,
      account: [ Object, Array ],
      biz: [ Object, Array ]
    },

    data() {
      return {
        rsv: false,
        rsvs: [],
      }
    },

    firestore() {
      return {
        rsvs: {
          ref: db.collection('reservations').where( 'account_id', '==', this.account.id )
        },
      }
    },

    computed: {
      // opening() {
      //   if ( !this.biz.cfg || !this.biz.cfg.opening ) return 8 * 60
      //   let d = new Date(this.biz.cfg.opening)
      //   let mins = d.getHours() * 60 + d.getMinutes()
      //   return mins
      // },

      // closing() {
      //   if ( !this.biz.cfg || !this.biz.cfg.closing ) return 20 * 60
      //   let d = new Date(this.biz.cfg.closing)
      //   let mins = d.getHours() * 60 + d.getMinutes()
      //   return mins
      // },

      events() {
        return this.rsvs.map( r => ({...r, ...{
          startDate: r.datetime.start.toDate(),
          endDate: r.datetime.end.toDate(),
          class: this.klass(r),
          content: '<img src="/ui/customer-w.svg" width="20">'
        }}))
      },
    },

    methods: {
      klass(evt) {
        let styles = ''

        if ( evt.datetime.end.toDate() > new Date() ) {
          if ( evt.account_id == this.account.id ) styles += 'customer'
          if ( this.biz.id == evt.business_id ) styles += 'merchant'
          if ( evt.status == 'Pending Cancellation' ) styles += ' pending'
          if ( evt.status == 'Canceled' ) styles += ' canceled'
          if ( evt.name ) styles = ''
        }

        return styles
      },

      scrollToNow() {
        const calendar = document.querySelector('.vuecal__bg')
        const today = new Date()
        const hours = today.getHours()*60+120
        calendar.scrollTo({ top: hours, behavior: 'smooth' })
      },

      view(evt) {
        this.rsv = evt
      }
    },

    created() {
    },

    mounted() {
      // let el = document.getElementById('rsv-cal')
      // if ( el ) el.scrollTo(0, 767)
    }
  }
</script>

<style scoped lang='stylus'>
  header
    display flex
    padding 10px 0
    .legend-item
      margin-right 32px
      .text
        font-weight bold
      .clr
        display inline-block
        height 24px
        width 24px
        vertical-align middle
        margin-right 12px
        &.non
          background rgb( 200 200 200 )
        &.cus
          background orange
          .cus2
            margin-left 2px
            margin-top 2px
        &.mer
          background green
        &.can-cus
          background rgb( 250 215 165 )
        &.can-mer
          background rgb( 160 210 175 )
  .section-heading
    padding 4px 8px 8px 8px

  .rsv-cal
    height 720px
    @media( max-width: 560px )
      height 440px
    .cal
      margin-top 16px

  >>> .vuecal__event
    height 100%

  >>> .customer
    background orange
    color white

  >>> .merchant
    background green
    color white
    height 100%

  >>> .pending
    border 1.5px solid red

  >>> .canceled
    color red
    &.merchant
      background rgb( 160 210 175 )
    &.customer
      background rgb( 250 215 165 )
    .vuecal__event-title, .vuecal__event-time
      display none

    &::after
      height 100%
      display flex
      align-items center
      justify-content center
      content 'Canceled'
      transform rotate( -15deg )
    
  >>> .vuecal__flex.vuecal__title, >>> .vuecal__flex.weekday-label
    font-weight bold
  
  >>> .vuecal--week-view, >>> .vuecal--month-view, >>> .vuecal--day-view 
    border 2px solid grey
    border-radius 5px
    background rgb(250 250 250)
  
  >>> .vuecal__cell.selected
    background rgb(120 120 244)
  >>> .weekday-label
    font-weight bold
  >>> .vuecal__heading.today
    font-weight bold
    background rgb(54 131 149)
    color white
  
  >>> .vuecal__cell--today 
    background rgba(255 255 255 .9)
    font-weight bold
  
  >>> .vuecal__cell.today
    background rgb(54 131 149)
    color orange
  >>> .vuecal__cells.month-view
    font-size 1.3em
  >>> .vuecal__time-column
    font-weight bold
    background rgb(54 131 149)
  >>> .vuecal__time-cell
    color white
  >>> .vuecal--month-view
    height 450px
  >>> .vuecal--month-view.today
    color orange
  >>>  .vuecal__cell-events-count
    background orange 

  >>> .vuecal__cell-events
    // background gray
    // height 100%
    // color blue
  >>> .vuecal__now-line
    color orange
    border-top: 3px solid
</style>
